<script lang="ts" setup>
import { DrawerOverlay } from 'vaul-vue';
import { type HtmlHTMLAttributes } from 'vue';

import { cn } from '@/components/lib/shadcn-vue/utils';

import type { DialogOverlayProps } from 'radix-vue';
const props = defineProps<DialogOverlayProps & { class?: HtmlHTMLAttributes['class'] }>();
const delegatedProps = computed(() => {
  const { ...delegated } = props;
  return delegated;
});
</script>

<template>
  <DrawerOverlay v-bind="delegatedProps" :class="cn('fixed inset-0 z-[200] bg-black/80', props.class)" />
</template>
